import { render, staticRenderFns } from "./TaxDetail.vue?vue&type=template&id=024959fa&scoped=true"
import script from "./TaxDetail.vue?vue&type=script&lang=js"
export * from "./TaxDetail.vue?vue&type=script&lang=js"
import style0 from "./TaxDetail.vue?vue&type=style&index=0&id=024959fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024959fa",
  null
  
)

export default component.exports